import _ from 'lodash';
import { log, jwt_decode } from '@swiper/core';

export default function connectionSetup( app ) {

  function channels( ...args ) {
    const chans = _.uniq( _.compact( _.flattenDeep( args ) ) );
    if ( ! chans.length ) return;
    return app.channel( ...chans );
  }
  function do_channels( action, ...args ) {
    const chans = channels( ...args );
    if ( ! chans ) return;
    return chans[ action ]( this );
  }

  app.on( 'connection', connection => {
    Object.defineProperty( connection, 'join', {
      value : do_channels.bind( connection, 'join' ),
    } );
    Object.defineProperty( connection, 'leave', {
      value : do_channels.bind( connection, 'leave' ),
    } );
  } );

}
